import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const description = () => css`
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const descriptionPopoverWrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 18rem;
  padding: ${theme.remSize[150]};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    min-width: 25rem;
  }
`;
